import PrimaryControlsPane from './PrimaryControlsPane';

export default PrimaryControlsPane;
